import classNames from 'classnames'
import React from 'react'

if (process.env.BROWSER) require('../../styles/Icons/MJML.less')

export default ({ white, text }) => {
  const className = classNames('Icon Icon-MJML', {
    'is-white': white,
    'with-text': text
  })

  const dimensions = {
    height: 250,
    width: text ? 780 : 200
  }

  return (
    <svg
      className={className}
      height={dimensions.height}
      viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
      width={dimensions.width}>
      { text &&
        <g>
          <path d="M268,258a5,5,0,0,0,5,5h20a5,5,0,0,0,5-5V204c2-7,8-16,21-16s18,8,18,21v49a5,5,0,0,0,5,5h18a5,5,0,0,0,5-5V208c0-4,0-9,0-9a25,25,0,0,1,21-10c12,0,18,8,18,21v49a5,5,0,0,0,5,5h20a5,5,0,0,0,5-5V211c0-26-12-49-43-49-18,0-31,11-35,15-8-10-18-15-32-15a45,45,0,0,0-33,15l-3-9a4,4,0,0,0-4-3h-9a5,5,0,0,0-5,5v89Zm192,31c0,14-6,22-17,22s-11-3-15-5-5-1-6,1l-8,16a5,5,0,0,0,1,6c4,4,16,10,29,10,26,0,46-17,46-50V169a5,5,0,0,0-5-5H464a5,5,0,0,0-5,5V289Zm60-31a5,5,0,0,0,5,5h20a5,5,0,0,0,5-5V204c2-7,8-16,21-16s18,8,18,21v49a5,5,0,0,0,5,5h18a5,5,0,0,0,5-5V208c0-4,0-9,0-9a25,25,0,0,1,21-10c12,0,18,8,18,21v49a5,5,0,0,0,5,5h20a5,5,0,0,0,5-5V211c0-26-12-49-43-49-18,0-31,11-35,15-8-10-18-15-32-15a45,45,0,0,0-33,15l-3-9a4,4,0,0,0-4-3h-9a5,5,0,0,0-5,5v89Zm192,0a5,5,0,0,0,5,5h21a5,5,0,0,0,5-5V95a5,5,0,0,0-5-5H716a5,5,0,0,0-5,5V258Z" transform="translate(-20 -90)" className="fill-1" />
          <path d="M474,145a17,17,0,1,0,0-34,17,17,0,0,0,0,34h0Z" transform="translate(-20 -90)" className="fill-2" />
          <path d="M782,257a17,17,0,1,0,0-34,17,17,0,0,0,0,34h0Z" transform="translate(-20 -90)" className="fill-2" />
        </g> }
      <circle cx="176" cy="58" r="21" className="fill-1" />
      <rect y="38" width="136" height="40.99" rx="20" ry="20" className="fill-1" />
      <circle cx="21" cy="123" r="21" className="fill-2" />
      <rect x="81" y="193" width="136" height="40.99" rx="20" ry="20" transform="translate(278 337) rotate(180)" className="fill-1" />
      <circle cx="176" cy="188" r="21" className="fill-1" />
      <rect y="168" width="136" height="40.99" rx="20" ry="20" className="fill-1" />
    </svg>
  )
}
